export function getBoardsWithCards(mineCards) {
  if (!mineCards?.data?.data?.responseData) {
    return new Set();
  }

  return new Set(
    mineCards.data.data.responseData.map((card) => card.card.board_id)
  );
}

export function getVisibleBoardList({
  activeBoard = [],
  isAssignToMe = false,
  boardsWithCards = new Set(),
}) {
  if (!isAssignToMe) {
    return activeBoard;
  }

  return activeBoard.filter((board) => boardsWithCards.has(board.board_id));
}

export function getFilteredBoards({
  boards = [],
  searchQuery = "",
  checkedList = [],
}) {
  const normalizedQuery = searchQuery.toLowerCase();
  const visibleBoards = normalizedQuery
    ? boards.filter((board) =>
        board.board_name.toLowerCase().includes(normalizedQuery)
      )
    : boards;

  return [...visibleBoards].sort(
    (a, b) =>
      checkedList.includes(b.board_id) - checkedList.includes(a.board_id)
  );
}

export function getSelectedBoardIds({
  checkedList = [],
  boardId,
}) {
  return checkedList.includes(boardId)
    ? checkedList.filter((id) => id !== boardId)
    : [...checkedList, boardId];
}

export function getSelectAllBoardIds({
  boards = [],
  checkedList = [],
}) {
  const boardIds = boards.map((board) => board.board_id);
  const isAllSelected =
    boardIds.length > 0 &&
    boardIds.every((boardId) => checkedList.includes(boardId));

  return isAllSelected
    ? []
    : boardIds;
}
